import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query (v5) client.
 * Conservative defaults: no refetch on focus, 30s stale window, one retry.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
